export const ACCURACY_YEARS = 'years';
export const ACCURACY_MONTHS = 'months';
export const ACCURACY_WEEKS = 'weeks';
export const ACCURACY_DATE = 'date';
